export enum TypingStatus {
    none = 0,
    typing = 1,
    deleting = 2,
}
